'use strict';

angular.module('substoreApp.services')
    .service('optinProductTransformer', [function () {
        /** optin dialogs for order summary and order confirmation are identical in structure
         * to ordinary dialogs for order summary and order confirmation. Also, within
         * subscription template product content the optin dialogs contain fields having
         * same names and referencing correlated content as ordinary dialogs but tagged
         * with an additional keyword 'Optin'.
         * This transformer copies each tagged field to a field having a name w/o the keyword,
         * e.g. headerSubTitleOptinConfirmation is copied to eaderSubTitleConfirmation
         */
        return {
            transform: function(product, keyword) {

                function strip(propertyType) {
                    var object = product[propertyType];

                    angular.forEach(object, function(value, key) {
                        var i = key.indexOf(keyword);
                        if (i > -1) {
                            var newKey = key.replace(keyword, '');
                            object[newKey] = value;
                        }
                    });
                }

                angular.forEach(product.textLists, function(textList, key) {
                    var texts = [];
                    angular.forEach(textList, function(text) {
                        if (text)
                            texts.push(text);
                    });

                    product.textLists[key] = texts;
                });

                angular.forEach(["buttons", "footnotes", "hyperlinks", "images", "textLists", "texts"], strip);

                return product;
            }
        }

    }]);